import { render, staticRenderFns } from "./InventoryItemSelect.vue?vue&type=template&id=f5fa3ec8&scoped=true"
import script from "./InventoryItemSelect.vue?vue&type=script&lang=js"
export * from "./InventoryItemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fa3ec8",
  null
  
)

export default component.exports